<!-- #211 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Carrier City
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="countryList"
      :loading="loaderCity"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-row class="mt-0">
          <v-col cols="12" md="6" class="d-flex flex-column align-left pt-3">
            <v-toolbar-title class="pl-4 text-h6"> Upload </v-toolbar-title>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end pt-3">
            <template>
              <router-link
                class="text-decoration-none"
                :to="{
                  name: 'CountryUpload',
                  params: { id: selectedCarriedId },
                }"
              >
                <v-btn
                  color="primary"
                  class="mr-2"
                  small
                  :loading="countriesLoader"
                  v-if="
                    checkPermission('app_carrier_partner:carrier-country-list')
                  "
                  >Carrier Coverage Upload</v-btn
                >
              </router-link>
              <v-btn
                color="success"
                :loading="rsaLoader"
                small
                class="mr-2"
                @click="checkRsaCountry"
                v-if="
                  checkPermission(
                    'app_carrier_partner:rsa-carrier-country-city'
                  )
                "
                >Compare Carrier and RSA City</v-btn
              >
            </template>
            <div class="d-flex">
              <v-dialog
                v-model="rsaDialog"
                max-width="550px"
                @keydown.esc="rsaDialog = false"
              >
                <v-card>
                  <v-card-title>
                    <span class="headline">Check RSA City</span>
                  </v-card-title>
                  <v-divider class="mb-4"></v-divider>
                  <v-card-text>
                    <v-form ref="form" lazy-validation>
                      <v-row>
                        <v-col>
                          <v-file-input
                            v-model="countryFile"
                            counter
                            show-size
                            accept=".xlsx"
                            label="Select your Excel file"
                            :rules="[(v) => !!v || 'Please select Excel File']"
                            outlined
                            class="pb-0"
                          >
                          </v-file-input>
                          <v-btn
                            color="primary"
                            dark
                            class="mt-3"
                            :loading="fileLoader"
                            @click="uploadRsaCountryList"
                          >
                            Upload
                          </v-btn>
                          <v-btn
                            color="info"
                            class="mt-3 ml-3"
                            :loading="downloader"
                            @click="downloadRSACountryTemplate()"
                            >Download Template</v-btn
                          >
                          <v-btn class="mt-3 ml-3" @click="rsaDialog = false">
                            Cancel
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="d-flex">
              <v-dialog
                v-model="dialog"
                v-if="dialog"
                max-width="550px"
                @keydown.esc="dialog = false"
              >
                <v-card>
                  <v-card-title>
                    <span class="headline">City Upload</span>
                  </v-card-title>
                  <v-divider class="mb-4"></v-divider>
                  <v-card-text>
                    <v-form ref="form" lazy-validation>
                      <v-row>
                        <v-col>
                          <v-file-input
                            v-model="file"
                            counter
                            show-size
                            accept=".xlsx"
                            label="Select your Excel file"
                            :rules="[(v) => !!v || 'Please select Excel File']"
                            outlined
                            class="mb-0"
                          >
                          </v-file-input>
                          <v-btn
                            color="primary"
                            dark
                            class="mt-3"
                            :loading="fileLoader"
                            @click="uploadCityDetails"
                          >
                            Upload
                          </v-btn>
                          <v-btn
                            color="info"
                            class="mt-3 ml-3"
                            :loading="downloader"
                            @click="downloadCityyDetails()"
                            >Download template</v-btn
                          >
                          <v-btn class="mt-3 ml-3" @click="dialog = false">
                            Cancel
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <v-select
              v-model="selectedCarriedId"
              label="Carriers"
              :rules="[(v) => !!v || 'Carriers is required.']"
              class="required pt-0"
              item-text="name"
              item-value="id"
              ref="selectCarrier"
              :items="activeCarriersListTypes"
              @change="carrierTypeList()"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col>
            <h4 class="mx-4">Upload Coverage City Name</h4>
            <v-row class="p-0">
              <v-col>
                <div class="d-flex align-center">
                  <div class="mx-4 f-14 pt-0">
                    Upload the available city coverage for the carrier
                  </div>
                  <v-btn
                    color="primary"
                    :loading="fileLoader"
                    small
                    class="mr-2 city-data"
                    @click="uploadcity"
                    v-if="
                      checkPermission(
                        'app_carrier_partner:import-carrier-country-city'
                      ) && selectedCarriedId
                    "
                    >City Upload</v-btn
                  >
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <div class="d-flex align-center pt-0">
                  <div class="mx-4 f-14 pt-0">
                    Download the existing city data of the carrier
                  </div>

                  <v-btn
                    color="info"
                    small
                    :loading="downloader"
                    @click="downloadCityyDetails()"
                    class="mr-4 data"
                    v-if="
                      checkPermission(
                        'app_carrier_partner:download-carrier-country-city'
                      ) &&
                      selectedCarriedId &&
                      countryList.length > 0
                    "
                    >Download Data</v-btn
                  >
                </div>
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-4"></v-divider>
          </v-col>
        </v-row>
        <h4 class="mx-4 mt-4">List of carrier city upload</h4>
      </template>
      <template v-slot:[`item.is_final_event`]="{ item }">
        <div v-if="item.is_final_event === false">No</div>
        <div v-else>Yes</div>
      </template>
    </v-data-table>
    <Area class="mt-2" :carrier_id="selectedCarriedId" />
    <Pincode class="mt-2" :carrier_id="selectedCarriedId" />

    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";
import Area from "@/views/front/carriers/AreaUpload.vue";
import Pincode from "@/views/front/carriers/PincodeUpload.vue";

export default {
  components: {
    BulkErrors,
    Area,
    Pincode,
  },
  computed: {
    ...mapGetters(["activeCarriersListTypes"]),
  },
  data: () => ({
    headers: [
      {
        text: "City Name",
        value: "carrier_city_name",
        width: "150px",
        sortable: false,
      },
      {
        text: "Country Name",
        value: "country",
        sortable: false,
      },
      {
        text: "RSA City",
        value: "rsa_city",
        sortable: false,
      },
    ],
    formData: {},
    countryList: [],
    loaderCity: false,
    dialog: false,
    file: null,
    fileLoader: false,
    downloader: false,
    uploadRes: {},
    uploadResDialog: false,
    selectedCarriedId: {
      name: null,
      id: null,
    },
    total: 0,
    options: {},
    countriesLoader: false,
    other: "verify",
    rsaDialog: false,
    rsaLoader: false,
    countryFile: null,
  }),

  watch: {
    options: {
      handler() {
        this.carrierTypeList();
      },
      deep: true,
    },
  },

  created() {
    this.selectedCarriedId = this.$route.params.id;
    if (this.selectedCarriedId !== null && this.selectedCarriedId == "")
      this.carrierTypeList();
    this.getActiveCarriersListTypes();
  },

  methods: {
    ...mapActions([
      "getCitiesList",
      "uploadCityList",
      "downloadCityList",
      "getActiveCarriersListTypes",
      "snackBar",
      "downloadSampleRSACountry",
      "uploadrRsaCountry",
    ]),
    uploadcity() {
      if (typeof this.selectedCarriedId == "number") {
        this.dialog = true;
      } else {
        this.dialog = false;
        this.snackBar({
          color: "error",
          message: "Carriers is required",
        });
      }
    },
    checkRsaCountry() {
      this.rsaDialog = true;
    },
    fetchEventsList() {
      this.loader = true;
      this.getEvents({
        carrier_id: this.$route.query.carrier_id,
        params: {
          ...this.options,
        },
      })
        .then((res) => {
          this.loader = false;
          this.eventsUpload = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    uploadCityDetails() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file);
      payload.append("carrier_id", this.selectedCarriedId);
      this.uploadCityList(payload)
        .then((res) => {
          this.fileLoader = false;
          this.dialog = false;
          this.uploadRes = res.data;
          this.uploadResDialog = true;
          this.carrierTypeList();
        })
        .catch(() => {
          this.fileLoader = false;
        });
    },
    downloadCityyDetails() {
      if (typeof this.selectedCarriedId == "number") {
        this.downloader = true;
        const payload = new FormData();
        payload.append("carrier_id", this.selectedCarriedId);
        this.downloadCityList(payload)
          .then((res) => {
            this.fileDownload(res);
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      } else {
        this.snackBar({
          color: "error",
          message: "Carriers is required",
        });
      }
    },
    carrierTypeList() {
      if (
        this.selectedCarriedId !== "" &&
        typeof this.selectedCarriedId == "number"
      ) {
        this.loaderCity = true;

        this.getCitiesList({
          option: this.options,
          id: this.selectedCarriedId,
        }).then((res) => {
          this.loaderCity = false;
          this.countryList = res.data.records;
          this.total = res.data.total;
        });
      }
    },
    uploadRsaCountryList() {
      if (!this.$refs.form.validate()) return;
      this.rsaLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.countryFile);
      this.uploadrRsaCountry(payload)
        .then((res) => {
          this.rsaLoader = false;
          this.rsaDialog = false;
          this.fileDownload(res);
          this.snackBar({
            color: "success",
            message: "Data downloaded successfully",
          });
        })
        .catch(() => {
          this.rsaLoader = false;
        });
    },
    downloadRSACountryTemplate() {
      this.downloaderRSA = true;
      this.downloadSampleRSACountry()
        .then((res) => {
          this.fileDownload(res);
          this.snackBar({
            color: "success",
            message: "Data downloaded successfully",
          });
          this.downloaderRSA = false;
        })
        .catch(() => {
          this.downloaderRSA = false;
        });
    },
  },
};
</script>
<style>
.f-14 {
  font-size: 14px;
}
.data {
  margin-left: 20px;
}
.city-data {
  width: 135px;
}
</style>
